'use strict';

export function errorStatistics(status, path) {
    //Fel/[namn på fel]/[view id för sida om det går att ta fram]
    return {
        orvestoData: '/fel/fel/' + status,
        dataLake: {
            product: {
                viewId: `fel/${status}${path}`,
                viewType: 'fel',
            },
        },
    };
}
